<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import PrivacyPolicyContent from '@/Components/Legal/PrivacyPolicyContent.vue'
</script>

<template>
  <AppLayout>
    <div class="max-w-4xl mx-auto px-4 py-16">
      <h1 class="text-4xl font-bold text-gray-900 mb-8">Bindle Tutor Privacy Policy</h1>
      <PrivacyPolicyContent />
    </div>
  </AppLayout>
</template>
